export default __webpack_public_path__ + "static/why-us-cover-img-ff8d01e51566765005aef6b1a7cf2350.webp";